export default __webpack_public_path__ + "static/media/home_gif.ab9d4bf1.mp4";